import { useEffect, Suspense, lazy } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { useInjectReducer, useInjectSaga } from '../../utils/injectors';
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from 'react-helmet-async';
import Reducer, { reducer, saga } from '../AppProvider/AppProvider.reducer';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import * as Constants from '../../utils/constants';
import * as Functions from '../../utils/functions';
import * as Routes from '../../utils/routes';
import {
  AuthenticatedRoute,
  ToAuthenticateRoute,
  PublicRoute,
} from '../../utils/middleware';

import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import DynamicDialog from '../../containers/DynamicDialog/DynamicDialog';
import GalleryModal from '../../containers/GalleryModal/GalleryModal';
import Camera from '../../containers/Camera/Camera';
import Snackbar from '../../containers/Snackbar/Snackbar';

import './App.scss';
import 'flag-icons/css/flag-icons.min.css';
import "material-icons/iconfont/material-icons.css";
import "@fontsource/eb-garamond/index.css";
import "@fontsource/fuzzy-bubbles/index.css";

const App = props => {
  const {
    loading,

    loadSystemSetting,
    loadArticleCategories,
  } = props;

  useInjectReducer({ key: 'app', reducer });
  useInjectSaga({ key: 'app', saga: saga });

  useEffect(() => {
    loadSystemSetting();
    loadArticleCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com"></link>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
      </Helmet>

      <ThemeProvider theme={createTheme(Constants.Theme.Default)}>

        <LoadingIndicator loading={loading} />

        <RouterProvider router={router} />

      </ThemeProvider>

    </HelmetProvider>
  );
};

export default Reducer.connector({
  loading: Reducer.makeSelector('loading'),
})(App);

const RouterWrapper = (Component) => (
  <Suspense fallback={<div>..</div>}>

    <DynamicDialog />
    <GalleryModal />
    <Camera />
    <Snackbar />

    <Component />
  </Suspense>
);

const router = createBrowserRouter(
  Functions.General.getConstant(Routes.Page).list.map(route => {
    const Component = lazy(() => import(`../../${route.componentPath}`));

    if (route.typeCode === Routes.Type.System.code) {
      return {
        path: route.locationPath,
        element: RouterWrapper(Component),
      }
    }
    if (route.typeCode === Routes.Type.Public.code) {
      return {
        path: route.locationPath,
        element: <PublicRoute>{RouterWrapper(Component)}</PublicRoute>,
      }
    }
    if (route.typeCode === Routes.Type.Authenticated.code) {
      return {
        path: route.locationPath,
        element: <AuthenticatedRoute>{RouterWrapper(Component)}</AuthenticatedRoute>,
      }
    }
    if (route.typeCode === Routes.Type.ToAuthenticate.code) {
      return {
        path: route.locationPath,
        element: <ToAuthenticateRoute>{RouterWrapper(Component)}</ToAuthenticateRoute>,
      }
    }
    return {};
  })
);